export const MESSAGES = {
  SOMETHING_WENT_WRONG: 'Something went wrong',
  INTERNAL_ERROR: 'Internal error',
  SERVER_ERROR: 'Server error',
  UNAUTHORIZED: 'Unauthorized',
  BAD_GATEWAY: 'Bad gateway',
};
